// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hg_W","badges":"styles_badges__nyHjm"};